/** МК с 100+ покупок — показываем бейдж на карточке */
export const POPULAR_MASTERCLASS_PURCHASE_MIN = 100;

const getPurchaseMilestone = (count: number) => {
  if (count < POPULAR_MASTERCLASS_PURCHASE_MIN) {
    return null;
  }

  return Math.floor(count / 100) * 100;
};

export const formatPurchaseCountBadge = (count: number) => {
  const milestone = getPurchaseMilestone(count);

  if (!milestone) {
    return '';
  }

  return `Связали ${milestone}+ рукодельниц`;
};

export const formatPurchaseCountBadgeTitle = (count: number) => {
  const milestone = getPurchaseMilestone(count);

  if (!milestone) {
    return '';
  }

  return `Более ${milestone} рукодельниц уже связали по этому мастер-классу`;
};

export const isPopularMasterclassByPurchases = (
  purchaseCount: number | null | undefined,
) => (purchaseCount ?? 0) >= POPULAR_MASTERCLASS_PURCHASE_MIN;
